import React, { memo } from 'react';
import ReactPlayer from "react-player";
import '../../Styles/FAQ.css'
// import { Col } from 'react-bootstrap';

/**
 * Checks whether the respective video is visible to logged-in user.
 * @param videoData
 * @param loggedInUserRole
 * @returns {boolean}
 */
function isVisible(videoData, loggedInUserRole) {
    let checkVisibility = false;
    videoData.visible.forEach(checkFunction)

    function checkFunction(videoVisibleItem) {

        if (checkVisibility === false) {
            checkVisibility = loggedInUserRole.includes(videoVisibleItem);
        }
    }

    return checkVisibility === true;
}

/**
 * Shows the respective video with visibility check depending on user role.
 * @param videoData
 * @returns {JSX.Element}
 * @constructor
 */
const TrainingVideosListItem = ({ videoData }) => {


    let loggedInUserRole = sessionStorage.getItem('roles')
    if (isVisible(videoData, loggedInUserRole)) {
        return (
            // <Col sm={3} style={{
            //     // background: 'red',
            //     // flexGrow:1,
            //     margin: 10,
            //     paddingBottom: 10,
            //     height:'500px',
            //     boxSizing:'content-box',
            // }}>
            //     <h5>{videoData.name}</h5>
            //     <ReactPlayer
            //         controls={true}
            //         width={'100%'}
            //         url={videoData.URL}
            //     />
            // </Col>
            <div style={{
                margin: 10,
                paddingBottom: 10,
                // maxWidth:'30%',
                height:'auto',
                objectFit:'cover',
            }}>
                <h5 style={{
                    width:'28rem'
                }}>{videoData.name}</h5>
                <ReactPlayer
                    controls={true}
                    width={'100%'}
                    url={videoData.URL}
                />
            </div>
        )
    }

}

export default memo(TrainingVideosListItem);